import Abank24 from './views/abank24.c';
export default Abank24;
